export default __webpack_public_path__ + "static/media/brand-00.205c6adb.jpg";